/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".line[_ngcontent-%COMP%]{border-top:1px solid #c1c1c1;padding-top:30px}table[_ngcontent-%COMP%]{border:none}.vertical-middle[_ngcontent-%COMP%]{vertical-align:middle}.have-image[_ngcontent-%COMP%]{color:#10a800}.image-icon[_ngcontent-%COMP%]{width:0%;text-align:center}.table-general-info[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{font-size:14px;font-weight:400}.table-general-info[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:hover{color:unset}\n/*# sourceMappingURL=general-information.component.css.map*/"];
export { styles as styles };
